import { isMobile } from './commonUtils';

const { getAppEnv } = require('../../config/env');
const env = getAppEnv();
const { STATIC_PAGE_URL } = env.raw;

export const WHY_BOOK_WITH_US_TITLE = 'Why Book Train with us?';
export const SERVER_URL = 'https://railways.makemytrip.com/api';

export const WEB_VITAL_URL = 'https://railways.makemytrip.com/api/webVitals';

export const PARTIAL_URLS = {
  CREATE_ACCOUNT_PAGE: `irctc-create-account.html`,
  FORGOT_PASSWORD_PAGE: `irctc-forgot-password.html`,
  FORGOT_USERNMAE_PAGE: `irctc-forgot-username.html`,
  CAPCHA_PAGE_URL: `irctc-login.html#capcha`,
  WRONG_CREDENTIALS_PAGE: `irctc-login.html#wrongCredentials`,
  IRCTC_LOGIN: `irctc-login.html`
};

export const RUNTIME_URL = STATIC_PAGE_URL;

export const IRCTC_PAGE_URLS = {
  CREATE_ACCOUNT_PAGE: `${RUNTIME_URL}/${PARTIAL_URLS.CREATE_ACCOUNT_PAGE}`,
  FORGOT_PASSWORD_PAGE: `${RUNTIME_URL}/${PARTIAL_URLS.FORGOT_PASSWORD_PAGE}`,
  FORGOT_USERNMAE_PAGE: `${RUNTIME_URL}/${PARTIAL_URLS.FORGOT_USERNMAE_PAGE}`,
  CAPCHA_PAGE_URL: `${RUNTIME_URL}/${PARTIAL_URLS.CAPCHA_PAGE_URL}`,
  WRONG_CREDENTIALS_PAGE: `${RUNTIME_URL}/${PARTIAL_URLS.WRONG_CREDENTIALS_PAGE}`,
  IRCTC_LOGIN: `${RUNTIME_URL}/${PARTIAL_URLS.IRCTC_LOGIN}`
};

const IRCTC_FORMS_COMMON_COMPONENTS = {
  inputForm: 'inputForm',
  successPage: 'successPage'
};
export const IRCTC_CREATE_ACCOUNT_COMPONENTS = {
  ...IRCTC_FORMS_COMMON_COMPONENTS,
  otpVerificationForm: 'otpVerificationForm'
};

export const IRCTC_FORGOT_PASSWORD_COMPONENTS = {
  ...IRCTC_FORMS_COMMON_COMPONENTS
};

export const IRCTC_FORGOT_USERNAME_COMPONENTS = {
  ...IRCTC_FORMS_COMMON_COMPONENTS
};

export const IRCTC_RADIO_BUTTON_NAMES = {
  MaritalStatus: 'MaritalStatus',
  Gender: 'Gender'
};

export const IRCTC_CLICK_EVENT = {
  CREATE_ACCOUNT: 'seo_create_account',
  SEO_CREATE_ACCOUNT_SUCCESS: 'seo_create_account_success',
  SEO_CREATE_ACCOUNT_FAILED: 'seo_create_account_failed'
};

export {
  SEO_ROUTE_PAGE,
  SEO_TRAIN_PAGE,
  SEO_STATION_PAGE,
  SEO_SEAT_AVAILABILITY_PAGE,
  SEO_TRAIN_TYPE_PAGE,
  IRCTC_PAGE_NAME,
  IRCTC_INFO_PAGE_EVENT
} from '../analytics/constants';

export const MARRIAGE_STATUS_RADIO = {
  MARRIED: {
    key: 'MARRIED',
    value: 'M'
  },
  UNMARRIED: {
    key: 'UNMARRIED',
    value: 'F'
  }
};

export const RADIO_KEYS_LABELS_MARITAL_STATUS = [
  {
    optionKey: 'MARRIED',
    optionLabel: 'Married'
  },
  {
    optionKey: 'UNMARRIED',
    optionLabel: 'Unmarried'
  }
];

export const GENDER_RADIO = {
  MALE: {
    key: 'MALE',
    value: 'M'
  },
  FEMALE: {
    key: 'FEMALE',
    value: 'F'
  }
};

export const RADIO_KEYS_LABELS_GENDER = [
  {
    optionKey: 'MALE',
    optionLabel: 'Male'
  },
  {
    optionKey: 'FEMALE',
    optionLabel: 'Female'
  }
];

export const IRCTC_PASSWORD_RADIO = {
  MOBILE: {
    key: 'MOBILE',
    otpType: 'M'
  },
  EMAIL: {
    key: 'EMAIL',
    otpType: 'E'
  }
};

export const RADIO_KEYS_LABELS_IRCTC_PASSWORD = [
  {
    optionKey: 'MOBILE',
    optionLabel: 'Mobile number'
  },
  {
    optionKey: 'EMAIL',
    optionLabel: 'Email id'
  }
];

export const LANGUAGE_LIST = ['English', 'Hindi'];
export const LANGUAGES_DETAILS = Object.freeze({
  English: {
    key: 'en',
    value: 'English'
  },
  Hindi: {
    key: 'hi',
    value: 'Hindi'
  }
});

export const COUNTRIES_LIST = ['India'];
export const COUNTRIES_DETAILS = Object.freeze({
  India: {
    key: '94',
    code: 'IN',
    value: 'India'
  }
});

export const IRCTC_DATE_LIMITS = {
  fromDate: new Date(new Date().getFullYear() - 100, 0),
  toDate: new Date(new Date().getFullYear() - 18, 11)
};

export const IRCTC_FAQS = [
  {
    title: `What is IRCTC?`,
    info: `IRCTC, an acronym for Indian Railways Catering and Tourism Corporation, is a platform for online train ticket bookings. IRCTC is the only official website of Indian Railways for ticket booking. With this online platform, the dependence on the middlemen or agents for ticket booking has significantly dropped.
    Customers can now pay for their tickets without the discomfort of standing in long queues for hours.   With the help of an IRCTC account, you can now unlock new features with just some simple steps. Once you put in your IRCTC login details you can browse through every information you need on train ticket booking such as train availability, train schedule, PNR status, train fare, tatkal train ticket, ticket cancellation, and more.`
  },
  {
    title: `What is MakeMyTrip Trains ?`,
    info: `MakeMyTrip is one of the leading online IRCTC train ticket booking platforms. With MakeMyTrip easy online IRCTC login, customers do not need to physically visit the railway station and queue up in lines for hours. Now you can book your train tickets in just a few clicks from the comfort of your homes.

     IRCTC next generation ticketing system churns up several lakhs of bookings per day. It is the busiest site. Thus, MakeMyTrip makes it easier for customers to book their tickets with its quick and simple process of IRCTC registration and IRCTC account login. `
  },
  {
    title: `IRCTC Train Ticket Booking on MakeMyTrip`,
    info: `MakeMyTrip has made the process of online ticket booking very simple and one can book their tickets in easy steps. Before you start with the process, you must have your IRCTC login credentials handy.

      Step 1: Visit the MakeMyTrip official website and choose your arrival and departure stations.
      Step 2: Select the date of the journey and choose from the class of trains you want to book. You will see all the trains available with their departure and arrival timings along with the duration of the trip.
      Step 3: You can filter out by pricing, departure time, date, travel class, train types, and even stations.
      Step 4: After selecting your desired train, fill in your details with berth preference and other requirements.
      Step 5: Enter your IRCTC login username and proceed to pay. After a successful payment, enter your correct IRCTC login password to receive your ticket by mail. `
  },
  {
    title: `IRCTC Next Gen Ticket Booking Platform`,
    info: `The ticket booking system has been revolutionized with the introduction of the IRCTC next gen ticket booking platform. With the help of the IRCTC portal, many customers are at ease when it comes to ticket booking. IRCTC provides many services apart from online ticket booking. Some of the services available on the platform are as follows:

        1. I-tickets (regular tickets) which are delivered to your doorstep.
        2. Book buses, flights, holiday packages, and even hotel accommodations.
        3. Book your meals.
        4. Check loyalty and promotion schemes.
        5. Check foreign tourist booking.
        6. Check travel insurance claim process
        7. Cancellation of tickets and refund process.
        8. Check train schedule and track live train status.
        9. Check the PNR status `
  },
  {
    title: `IRCTC e-wallet`,
    info: `IRCTC e-wallet is a useful introduction by the Indian Railways for secure and hassle-free transactions for its customers. IRCTC e-wallet feature helps you with the ticket reservation in a much faster way. You can deposit the amount in your e-wallet in advance for your future transactions.

     Choose e-wallet as your payment mode while booking your ticket and complete the transaction with the balance amount in your e-wallet. The registration fee for the IRCTC e-wallet is INR 50, and the transaction charges are INR 10 (excluding GST) per booking. The benefit of having an e-wallet is that even if your tickets are canceled by you or IRCTC, you get an option of crediting the amount back to your e-wallet. In this way, you do not need to wait for refunds which will take up to 3 to 7 working days.

      Booking trains has become a hassle-free process due to the IRCTC's new and improved website. Being IRCTC premium partner, MakeMyTrip offers the benefits of hassle-free, secure, reliable, and cost-effective transactions to the customers. You can now book your tickets with the help of IRCTC login and navigate through numerous options and benefits awaiting you.
     `
  }
];

export const IRCTC_SIMILAR_QUESTIONS = [
  {
    question: 'My IRCTC Password reset limit is over, what can I do now?',
    hrefLink: 'https://www.makemytrip.com/railways/faq/my-irctc-password-reset-limit-is-over-what-can-i-do-now.html'
  },
  {
    question: 'How do I refresh the captcha given?',
    hrefLink: 'https://www.makemytrip.com/railways/faq/how-do-i-refresh-the-captcha-given.html'
  },
  {
    question: 'How can I book a train ticket on the MakeMyTrip App?',
    hrefLink: 'https://www.makemytrip.com/railways/faq/how-can-i-book-a-train-ticket-on-the-makemytrip-app.html'
  },
  {
    question: 'What do I do when the captcha given is not visible?',
    hrefLink: 'https://www.makemytrip.com/railways/faq/what-do-i-do-when-the-captcha-given-is-not-visible.html'
  },
  {
    question: 'How can I reset my IRCTC password?',
    hrefLink: 'https://www.makemytrip.com/railways/faq/how-can-i-reset-my-irctc-password.html'
  },
  {
    question: 'I want to book more than 6 tickets in a month. How do I link my Aadhaar?',
    hrefLink:
      'https://www.makemytrip.com/railways/faq/i-want-to-book-more-than-6-tickets-in-a-month-how-do-i-link-my-aadhaar.html'
  },
  {
    question: 'My train is waitlisted. How can I check alternate/nearby stations for the same train?',
    hrefLink:
      'https://www.makemytrip.com/railways/faq/my-train-is-waitlisted-how-can-i-check-alternate-nearby-stations-for-the-same-train.html'
  },
  {
    question:
      'I wanted to change Age/Gender/Name on the e-Ticket which I received after booking a train. Is there any way to do so?',
    hrefLink:
      'https://www.makemytrip.com/railways/faq/i-wanted-to-change-age-gender-name-on-the-e-ticket-which-i-received-after-booking-a-train-is-there-any-way-to-do-so.html'
  }
];

export const FACING_TROUBLE_PAGE_TITLE = {
  CREATE_ACCOUNT_TITLE: 'Create New Account',
  FORGOT_IRCTC_USERNAME_TITLE: 'Forgot / Recover IRCTC Username',
  FORGOT_IRCTC_PASSWORD_TITLE: 'Forgot / Recover IRCTC Password',
  INVALID_CAPCHA_TITLE: 'Invalid Captcha',
  WRONG_CREDENTIALS_TITLE: 'Wrong Credentials'
};

export const FACING_TROUBLE_LIST = [
  {
    title: FACING_TROUBLE_PAGE_TITLE.CREATE_ACCOUNT_TITLE,
    navigationUrl: IRCTC_PAGE_URLS.CREATE_ACCOUNT_PAGE
  },
  {
    title: FACING_TROUBLE_PAGE_TITLE.FORGOT_IRCTC_USERNAME_TITLE,
    navigationUrl: IRCTC_PAGE_URLS.FORGOT_USERNMAE_PAGE
  },
  {
    title: FACING_TROUBLE_PAGE_TITLE.FORGOT_IRCTC_PASSWORD_TITLE,
    navigationUrl: IRCTC_PAGE_URLS.FORGOT_PASSWORD_PAGE
  },
  {
    title: FACING_TROUBLE_PAGE_TITLE.INVALID_CAPCHA_TITLE,
    navigationUrl: IRCTC_PAGE_URLS.CAPCHA_PAGE_URL
  },
  {
    title: FACING_TROUBLE_PAGE_TITLE.WRONG_CREDENTIALS_TITLE,
    navigationUrl: IRCTC_PAGE_URLS.WRONG_CREDENTIALS_PAGE
  }
];

export const getFacingTroubleList = (titleOfElementToFilter) => {
  return FACING_TROUBLE_LIST.filter((element) => element.title !== titleOfElementToFilter);
};

export const IRCTC_LOGIN_ABOUT = [...FACING_TROUBLE_LIST];
export const FACING_TROUBLE_TITLE = 'Facing Troubles?';
export const ABOUT_IRCTC_TITLE = 'About IRCTC';
export const ABOUT_IRCTC_DESRIPTION =
  'IRCTC is an online platform for booking train tickets. Anyone who wants to book a train ticket on IRCTC needs to be registered with the platform. Every user is assigned an IRCTC User ID and IRCTC Password which is linked to their mobile number & email address. In order to successfully book a train ticket users need to input this User ID and password which is referred to as IRCTC Login. For users who face trouble while IRCTC login, MakeMyTrip offers variety of solutions, such as, recover IRCTC username, create new IRCTC username, Forgot password etc. You can check out these flows below. ';
export const CAPCHA_INFO_TITLE = 'What is Captcha?';
export const WRONG_CREDENTIALS_TITLE = `Wrong Credentials`;
export const WRONG_CREDETIALS_HEADER = 'What is bad credentials in IRCTC login?';
export const SIMILAR_QUESTIONS_TITLE = 'Similar Questions asked by our user';
export const IRCTC_FAQ_TITLE = `Frequently Asked Questions`;
export const FOOTER_DATA_IRCTC = `<footer>
    <ul class="footerLinks">
       <li class="latoBold capText">Product Offering</li>
       <li><a href="https://www.makemytrip.com/flights/">Flights</a></li>
       <li><a href="https://www.makemytrip.com/international-flights/">International Flights</a></li>
       <li><a href="https://www.makemytrip.com/hotels/"> Hotels</a></li>
       <li><a href="https://www.makemytrip.com/hotels-international/">International Hotels</a></li>
       <li><a href="https://www.makemytrip.com/holidays-india/">Holidays in India</a></li>
       <li><a href="https://www.makemytrip.com/holidays-international/">International Holidays</a></li>
       <li><a href="https://www.makemytrip.com/bus-tickets/">Bus</a></li>
       <li><a href="https://www.makemytrip.com/railways/">Rail</a></li>
       <li><a href="https://www.makemytrip.com/hotels/?ccde=ae">Book Hotels From UAE</a></li>
       <li><a href="https://www.makemytrip.com/blog/">Blog</a></li>
       <li><a href="https://www.makemytrip.com/railways/covid-special-trains.html">Covid Special Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/festive-special-trains.html">Festive Special Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/corona-virus-insurance-policy.html">Corona Health Insurance Policy</a></li>
        <li><a href="https://advertising.makemytrip.com/ad/solutions">MakeMyTrip Advertising Solutions</a></li>
       </ul>
    <ul class="footerLinks">
       <li class="latoBold capText">Top Hotel Cities</li>
       <li><a href="https://www.makemytrip.com/hotels/jaipur-hotels.html">Hotels in Jaipur</a></li>
       <li><a href="https://www.makemytrip.com/hotels/ooty-hotels.html">Hotels in Ooty</a></li>
       <li><a href="https://www.makemytrip.com/hotels/delhi-hotels.html">Hotels in Delhi</a></li>
       <li><a href="https://www.makemytrip.com/hotels/mumbai-hotels.html"> Hotels in Mumbai</a></li>
       <li><a href="https://www.makemytrip.com/hotels/chennai-hotels.html">Hotels in Chennai</a></li>
       <li><a href="https://www.makemytrip.com/hotels/kolkata-hotels.html">Hotels in Kolkata</a></li>
       <li><a href="https://www.makemytrip.com/hotels/goa-hotels.html">Hotels in Goa</a></li>
       <li><a href="https://www.makemytrip.com/hotels/bangalore-hotels.html">Hotels in Bangalore</a></li>
       <li><a href="https://www.makemytrip.com/hotels/shimla-hotels.html">Hotels in Shimla</a></li>
       <li><a href="https://www.makemytrip.com/hotels/munnar-hotels.html">Hotels in Munnar</a></li>
       <li><a href="https://www.makemytrip.com/hotels/agra-hotels.html">Hotels in Agra</a></li>
       <li><a href="https://www.makemytrip.com/hotels/mahabaleshwar-hotels.html">Hotels in Mahabaleshwar</a></li>
    </ul>
    <ul class="footerLinks">
       <li class="latoBold capText">Indian Railway</li>
       <li><a href="https://www.makemytrip.com/railways/">IRCTC</a></li>
       <li><a href="https://www.makemytrip.com/railways/PNR/"> PNR Status </a></li>
       <li><a href="https://www.makemytrip.com/railways/southern-railways.html">Southern Railway </a></li>
       <li><a href="https://www.makemytrip.com/railways/western-railways.html"> Western Railway </a></li>
       <li><a href="https://www.makemytrip.com/railways/indian-railways-seat-availability-irctc-trains-seat-availability-status.html">IRCTC Seat Availability</a></li>
       <li><a href="https://www.makemytrip.com/railways/indian-railways-time-table.html">Railway Time Table </a></li>
       <li><a href="https://www.makemytrip.com/railways/list-of-indian-railway-stations.html">Indian Railway Stations </a></li>
       <li><a href="https://www.makemytrip.com/railways/tatkal-railway-reservation.html">Taktal Reservation </a></li>
       <li><a href="https://www.makemytrip.com/railways/saharsa-jn-amritsar-jn-garib-rath-exp-12203-train.html">Garib Rath </a></li>
       <li><a href="https://www.makemytrip.com/railways/mysuru-jn-mgr-chennai-ctl-shatabdi-exp-12008-train.html">Shatabdi Express</a></li>
       <li><a href="https://www.makemytrip.com/railways/yesvantpur-jn-howrah-jn-duronto-express-12246-train.html"> Duronto Express</a></li>
       <li><a href="https://www.makemytrip.com/railways/new-delhi-lucknow-nr-gomti-express-12420-train.html">Gomti Express </a></li>
       <li><a href="https://www.makemytrip.com/railways/delhi-jammu-tawi-shalimar-exp-14645-train.html">Shalimar Express</a></li>
    </ul>
    <ul class="footerLinks">
       <li class="latoBold capText">Popular Routes</li>
       <li><a href="https://www.makemytrip.com/railways/bangalore-mysore-train-tickets.html">Bangalore to Mysore Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/mumbai-goa-train-tickets.html"> Mumbai to Goa Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/pune-mumbai-train-tickets.html"> Pune to Mumbai Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/delhi-jaipur-train-tickets.html"> Delhi to Jaipur Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/delhi-agra-train-tickets.html">Delhi to Agra Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/bangalore-goa-train-tickets.html">Bangalore to Goa Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/bangalore-chennai-train-tickets.html">Bangalore to Chennai Trains</a></li>
       <li><a href="https://www.makemytrip.com/railways/delhi-goa-train-tickets.html">Delhi to Goa Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/chennai-bangalore-train-tickets.html">Chennai To Bangalore Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/mumbai-pune-train-tickets.html">Mumbai To Pune Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/delhi-agra-train-tickets.html">Delhi To Agra Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/delhi-mumbai-train-tickets.html">Delhi To Mumbai Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/agra-delhi-train-tickets.html">Agra To Delhi Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/ahmedabad-mumbai-train-tickets.html">Ahmedabad To Mumbai Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/bhopal-delhi-train-tickets.html">Bhopal To Delhi Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/indore-jabalpur-train-tickets.html">Indore To Jabalpur Trains</a></li>

    </ul>
    <ul class="footerLinks">
       <li class="latoBold capText">More Popular Routes</li>
     <li><a href="https://www.makemytrip.com/railways/chennai-coimbatore-train-tickets.html">Chennai To Coimbatore Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/chennai-madurai-train-tickets.html">Chennai To Madurai Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/coimbatore-chennai-train-tickets.html">Coimbatore To Chennai Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/delhi-dehradun-train-tickets.html">Delhi To Dehradun Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/ahmedabad-delhi-train-tickets.html">Ahmedabad To Delhi Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/amritsar-delhi-train-tickets.html">Amritsar To Delhi Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/bangalore-delhi-train-tickets.html">Bangalore To Delhi Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/delhi-bangalore-train-tickets.html">Delhi To Bangalore Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/mumbai-surat-train-tickets.html">Mumbai To Surat Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/pune-delhi-train-tickets.html">Pune To Delhi Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/delhi-patna-train-tickets.html">Delhi To Patna Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/mumbai-udaipur-train-tickets.html">Mumbai To Udaipur Trains</a></li>
     <li><a href="https://www.makemytrip.com/railways/delhi-jabalpur-train-tickets.html">Delhi To Jabalpur Trains</a></li>

     </ul>
 </footer>
     `;
export const IRCTC_BREAD_CRUMB_COMMON = [
  {
    redirectionUrl: `https://www.makemytrip.com/`,
    displayString: `Home`
  },
  {
    redirectionUrl: `https://www.makemytrip.com/railways/`,
    displayString: `Rails`
  },
  {
    redirectionUrl: IRCTC_PAGE_URLS.IRCTC_LOGIN,
    displayString: 'IRCTC Login'
  }
];

// eslint-disable-next-line
export const IRCTC_EXTERNAL_JS = `<script type=\"text/javascript\">\r\n    window._mfq = window._mfq || [];\r\n    (function() {\r\n        var mf = document.createElement(\"script\");\r\n        mf.type = \"text/javascript\"; mf.async = true;\r\n        mf.src = \"//cdn.mouseflow.com/projects/72c486ff-f922-4afe-b557-1c7eba536034.js\";\r\n        document.getElementsByTagName(\"head\")[0].appendChild(mf);\r\n    })();\r\n</script>\r\n<script id='_webengage_script_tag' type='text/javascript'>\r\nvar webengage;!function(w,e,b,n,g){function o(e,t){e[t[t.length-1]]=function(){r.__queue.push([t.join(\".\"),\r\narguments])}}var i,s,r=w[b],z=\" \",l=\"init options track screen onReady\".split(z),a=\"feedback survey notification\".split(z),c=\"options render clear abort\".split(z),p=\"Open Close Submit Complete View Click\".split(z),u=\"identify login logout setAttribute\".split(z);if(!r||!r.__v){for(w[b]=r={__queue:[],__v:\"6.0\",user:{}},i=0;i < l.length;i++)o(r,[l[i]]);for(i=0;i < a.length;i++){for(r[a[i]]={},s=0;s < c.length;s++)o(r[a[i]],[a[i],c[s]]);for(s=0;s < p.length;s++)o(r[a[i]],[a[i],\"on\"+p[s]])}for(i=0;i < u.length;i++)o(r.user,[\"user\",u[i]]);setTimeout(function(){var f=e.createElement(\"script\"),d=e.getElementById(\"_webengage_script_tag\");f.type=\"text/javascript\",f.async=!0,f.src=(\"https:\"==e.location.protocol?\"https://ssl.widgets.webengage.com\":\"http://cdn.widgets.webengage.com\")+\"/js/webengage-min-v-6.0.js\",d.parentNode.insertBefore(f,d)})}}(window,document,\"webengage\");webengage.init(\"311c47d7\");\r\n</script>`;

export const CONTINUE_BOOKING_URL_MOBILE = 'https://www.makemytrip.com/railways/search';
export const CONTINUE_BOOKING_URL_DESKTOP = 'https://www.makemytrip.com/railways/';
export const getContinueBookingUrl = () => {
  return isMobile() ? CONTINUE_BOOKING_URL_MOBILE : CONTINUE_BOOKING_URL_DESKTOP;
};
export const CREATE_ACCOUNT_FORM_ELEMENT_ID = {
  userName: 'userName',
  userEmail: 'userEmail',
  mobileNumber: 'mobileNumber',
  password: 'password',
  securityQuestion: 'securityQuestion',
  securityAnswer: 'securityAnswer',
  firstName: 'firstName',
  lastName: 'lastName',
  selectedDate: 'selectedDate',
  selectedOccupation: 'selectedOccupation',
  selectedGender: 'selectedGender',
  selectedMaritalStatus: 'selectedMaritalStatus',
  selectedPreferredLanguage: 'selectedPreferredLanguage',
  residentialAddress: 'residentialAddress',
  alternateContact: 'alternateContact',
  selectedCountry: 'selectedCountry',
  pinCode: 'pinCode',
  officeCity: 'officeCity',
  officePostOffice: 'officePostOffice',
  officeRegionalState: 'officeRegionalState'
};

export const CODE_POINT_LOWER_LIMIT_FOR_ENGLISH_TEXT = 0;
export const CODE_POINT_UPPER_LIMIT_FOR_ENGLISH_TEXT = 128;
export const RAILS_LANG_CODE_HEADER_NAME = 'rails-lang-code';

export const APP_DOWNLOAD_BANNER = {
  english: 'english',
  englishHeader: 'Get app exclusive offers',
  englishSubHeader: 'Use code WELCOMEMMT on your 1st booking on app & get instant discounts.',
  englishOpenApp: 'Open App',
  englishInstallApp: 'Install App',
  hindiHeader: 'ऐप विशेष ऑफ़र प्राप्त करें',
  hindiSubHeader: 'रोमांचक डील और ऑफ़र के लिए ऐप डाउनलोड करें',
  hindiOpenApp: 'ऐप को ओपन करें',
  hindiInstallApp: 'ऐप को इंस्टॉल करें',
  appLink: 'https://app.mmyt.co/Xm2V/appinstalltrainslanding',
  omnitureShownEvent: 'big_appdownload_topstrip_shown',
  omnitureClickEvent: 'big_appdownload_topstrip_clicked'
};

export const RAILS_POKUS = {
  pokusApiUrl: 'https://pokus.makemytrip.com/experiment/assignVariant',
  timeoutInMilliSeconds: 350,
  totalPokusDataKeyForLocalStorage: 'rails_pokus',
  timeOutRejectError: 'Timeout Error in fetching pokus Api',
  pokusFetchError: 'Failed to load pokus api',
  lob: 'RAIL',
  postMethod: 'POST',
  mobile: 'mobile',
  desktop: 'desktop',
  userId: 'testUserId1',
  deviceId: 'testdevice1',
  success: 'SUCCESS',
  contentType: 'application/json',
  day: 24 * 60 * 60 * 1000
};

export const POKUS_KEYS = {
  tgspnrPage: 'Rails_Dweb_tgs_Seo_pnr_page'
};

export const TRAIN_TYPE = {
  TRAIN_NAME: 'Train Name',
  START_STATION: 'Start Station',
  START_TIME: 'Start Time',
  END_STATION: 'End Station',
  END_TIME: 'End Time',
  DISTANCE: 'Distance',
  ACTION: 'Action',
  BOOK_NOW: 'Book Now',
  KMS: 'kms',
  FQA_TITLE: 'Frequently Asked Questions',
  READ_MORE: '...read more',
  SHOW_LESS: ' show less',
  SELECT_DATE: 'Select Date'
};

export const MAX_NUMBER_OF_DAYS = 119;

const SHOW_ADS_AT_ON_TRAINS_LOWEST_INDEX = 5;
export const SHOW_ADS_ON_TRAIN_STATIONS_AT_INDEX = [SHOW_ADS_AT_ON_TRAINS_LOWEST_INDEX];

const SHOW_ADS_ON_ROUTES_AT_LOWEST_INDEX = 4;
export const SHOW_ADS_ON_ROUTE_TRAIN_LISTIN_AT_INDEX = [SHOW_ADS_ON_ROUTES_AT_LOWEST_INDEX];
